/**
 * @generated SignedSource<<65271c03ee270e22cb278d95cd6a39e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductRegistrationSectionOccurrenceFragment$data = {
  readonly atCapacity: boolean;
  readonly datetimeRange: ReadonlyArray<string>;
  readonly id: string;
  readonly " $fragmentType": "ProductRegistrationSectionOccurrenceFragment";
};
export type ProductRegistrationSectionOccurrenceFragment$key = {
  readonly " $data"?: ProductRegistrationSectionOccurrenceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductRegistrationSectionOccurrenceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductRegistrationSectionOccurrenceFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "atCapacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetimeRange",
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "420f3dfd069dcc7aca5436780fb37cd2";

export default node;
